import React from 'react';
import { FilterBadgeHookParams, AdCampaignObjectiveBadgeHookResult } from '../types';

interface AdCampaignObjective {
  id: string;
  name: string;
  objective: string;
}

interface UseAdCampaignObjectiveBadges extends FilterBadgeHookParams {
  adCampaignObjective: AdCampaignObjective[];
  adCampaignObjectivesQueryVariables?: string[];
}

export const useAdCampaignObjectiveBadges = ({
  adCampaignObjective,
  adCampaignObjectivesQueryVariables = [],
}: UseAdCampaignObjectiveBadges): AdCampaignObjectiveBadgeHookResult => {
  const adCampaignObjectiveBadges = React.useMemo(
    () => adCampaignObjective?.filter((objective) => adCampaignObjectivesQueryVariables.includes(objective.id)),
    [adCampaignObjective, adCampaignObjectivesQueryVariables],
  );

  return {
    adCampaignObjectiveBadgesProps: {
      data: adCampaignObjectiveBadges,
    },
  };
};
